import BaseApi from "../BaseApi";

const baseApi = new BaseApi();

export default class Study {
  Entity = "study";

  studyInfoForReport = async (studyID = null, requestID = null, includeReportHistory = false) => {
    const action = "getInfo";
    const processedData = {
      id: studyID,
      request_number: requestID,
      include_report_history: includeReportHistory,
    };

    return baseApi.fullFetch(this.Entity, action, {data: processedData})
  }

  updateFromHIS = async () => {
    const action = "updateFromHIS";

    return baseApi.fullFetch(this.Entity, action);
  }

  searchHIS = async (data = null) => {
    if (!data) {
      throw new Error("Data is null...!!!");
    }

    const action = "search";
    const processedData = {
      code: data?.code,
      name: data?.name,
      service_code_group_id: data?.request_code_id,
      limit: data?.limit,
      page: data?.page,
    };

    return baseApi.fullFetch(this.Entity, action, {data: processedData} )
  }
}
